import { useEffect, useState } from "react";

// Detecta especificamente iPhone (não iPad, não Android, não desktop).
// iPadOS 13+ manda UA de "Macintosh", então checamos touch points também
// pra não confundir iPad com Mac — mas aqui queremos SÓ iPhone, então
// isso serve pra excluir iPad da regra, não pra incluí-lo.
function detectIsIPhone() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || "";
  const isIPhoneUA = /iPhone/i.test(ua);
  return isIPhoneUA;
}

export default function useIsIPhone() {
  const [isIPhone, setIsIPhone] = useState(detectIsIPhone);

  useEffect(() => {
    const value = detectIsIPhone();
    setIsIPhone(value);
    const root = document.documentElement;
    if (value) {
      root.classList.add("ios-iphone");
    } else {
      root.classList.remove("ios-iphone");
    }
  }, []);

  return isIPhone;
}
